import React from 'react';
import { Heart, Gift, Sparkles } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Tagline */}
        <div className="text-center mb-16">
          <p className="text-neutral-600 mb-4 tracking-wide">
            Designed premium gifts for individuals, weddings, organizations and brands who
          </p>
          <p className="text-neutral-600 mb-8 tracking-wide">
            value restraint, storytelling and lasting recall.
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-800 mb-6 tracking-wide">
            THOUGHTFUL GIFTING, DESIGNED TO BUILD
          </h2>
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-800 mb-8 tracking-wide">
            LASTING RELATIONSHIPS
          </h2>
          <p className="text-neutral-700 max-w-3xl mx-auto mb-8 leading-relaxed">
            We, Guriva - a luxury gifting brand in India, believes in creating thoughtfully curated gift boxes and objects, suitable for personal celebrations, weddings, and relationship-led corporate gifting.
          </p>
          <a
            href="#collections"
            className="inline-block text-sm tracking-widest text-neutral-800 border-b border-neutral-800 hover:text-neutral-600 hover:border-neutral-600 transition-colors duration-300 uppercase"
          >
            Explore Signature Gift Collections
          </a>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-20">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-neutral-100 flex items-center justify-center">
                <Heart className="text-neutral-700" size={28} />
              </div>
            </div>
            <h3 className="text-lg font-serif mb-3 tracking-wide text-neutral-800">Made with Intention</h3>
            <p className="text-neutral-600 text-sm leading-relaxed">
              Every gift is carefully curated with thought and purpose, reflecting the sentiment behind each gesture.
            </p>
          </div>

          <div className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-neutral-100 flex items-center justify-center">
                <Sparkles className="text-neutral-700" size={28} />
              </div>
            </div>
            <h3 className="text-lg font-serif mb-3 tracking-wide text-neutral-800">Crafted with Care</h3>
            <p className="text-neutral-600 text-sm leading-relaxed">
              Attention to detail in every aspect, from selection to presentation, ensuring a memorable experience.
            </p>
          </div>

          <div className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-full bg-neutral-100 flex items-center justify-center">
                <Gift className="text-neutral-700" size={28} />
              </div>
            </div>
            <h3 className="text-lg font-serif mb-3 tracking-wide text-neutral-800">Personal Touch</h3>
            <p className="text-neutral-600 text-sm leading-relaxed">
              Because gifting is deeply personal to us, we ensure each piece tells a unique story.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;